export enum TINTypeEnum {
  SSN = 'ssn',
  EIN = 'ein',
}
